import React, { createContext, useContext, useState, ReactNode } from "react";
import { TruckDetailListing } from "../../models/TruckDetailListing";
interface truckMaterialFormFlowProviderProps {
  children: ReactNode;
}

interface truckMaterialFormFlowContextType {
  truckFormType: string;
  setTruckFormType: (truckAddFormType: string) => void;
}

const TruckMaterialFormFlowContext = createContext<
  truckMaterialFormFlowContextType | undefined
>(undefined);

export const useTruckMaterialFormFlowContext =
  (): truckMaterialFormFlowContextType => {
    const context = useContext(TruckMaterialFormFlowContext);
    if (!context) {
      throw new Error(
        "useTruckMaterialFormFlowContext must be used within a truckDetailProvider"
      );
    }
    return context;
  };

export const TruckMaterialFormFlowProvider: React.FC<
  truckMaterialFormFlowProviderProps
> = ({ children }) => {
  const [truckFormType, setTruckFormType] = useState("materialVendorFlow");

  return (
    <TruckMaterialFormFlowContext.Provider
      value={{
        truckFormType,
        setTruckFormType,
      }}
    >
      {children}
    </TruckMaterialFormFlowContext.Provider>
  );
};
